module["exports"] = [
  "Canada"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr_CA/address/default_country.js
// module id = 2339
// module chunks = 2